module.exports = __webpack_public_path__ + "static/step-3-e0e872b6a7addecb0648ae62286ad04d.png";